import React, { useEffect, useState } from 'react';
import NavigationStepper, {
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import { useAppContext } from '../../../../Services/AppContext';
import { useIsLatam } from '../../../Region/Services/region.service';
import useHealthPlanSteps from '../../Hooks/useHealthPlanSteps';
import HealthPlanCreateConfirmModal from '../HealthPlanCreateConfirm/HealthPlanCreateConfirmModal';
import { useHealthPlanUserHook } from '../../Hooks/useHealthPlanUser';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import useTranslation from '../../../../Hooks/useTranslation';
import { Flyer } from '../../../EArchive/Enums/Flyer.enum';
import FullPageLoading from '../../../../Components/Utils/FullPageLoading/FullPageLoading';
import { useModalContext } from '../../../Modal/Services/ModalContext';
import { TreatmentFormModalContextKeys } from '../../../../Components/Treatment/TreatmentFormModalContextKeys';

interface HealthPlanBabyCreateProps {
	patientId: string;
	workplaceId: string;
	onHealthPlanCreate?: () => void;
}

const HealthPlanBabyCreate: React.FC<HealthPlanBabyCreateProps> = ({
	patientId,
	workplaceId,
	onHealthPlanCreate,
}) => {
	const { t } = useTranslation();
	const [isCreateConfirmModalOpen, setIsCreateConfirmModalOpen] =
		useState(false);
	const [createIsRunning, setCreateIsRunning] = useState(false);
	const { globalTemplate } = useAppContext();
	const isLatam = useIsLatam(globalTemplate);
	const { submitData, loadHealthPlanUser } = useHealthPlanUserHook();
	const { healthPlan } = useHealthPlanContext();
	const { registerFormByKey, unregisterFormsByKey } = useModalContext();

	const handleCreatePlan = (promoCode?: string) => {
		unregisterFormsByKey([
			TreatmentFormModalContextKeys.MEDDI_BABY_CREATE_HEALTH_PLAN,
		]);
		setCreateIsRunning(true);
		if (healthPlan.code) {
			const result = submitData(
				patientId,
				healthPlan.code,
				{ ready: true, promoCode: promoCode },
				() => {
					setCreateIsRunning(false);
					setIsCreateConfirmModalOpen(true);
				},
			);
		}
	};
	const steps: NavigationStepperItemType[] = useHealthPlanSteps({
		patientId,
		workplaceId,
		afterPlanCreate: handleCreatePlan,
		onHealthPlanCreate,
	});

	const afterPlanCreate = async () => {
		setIsCreateConfirmModalOpen(false);
		if (healthPlan.code) {
			await loadHealthPlanUser(patientId, healthPlan.code);
		}
	};

	if (!isLatam) {
		useEffect(() => {
			registerFormByKey(
				TreatmentFormModalContextKeys.MEDDI_BABY_CREATE_HEALTH_PLAN,
			);
		}, []);
	}

	return (
		<>
			<NavigationStepper
				steps={steps}
				initialStepPath={isLatam ? 'patientInformation' : 'currentPregnancy'}
				canSkip={false}
			/>

			{isCreateConfirmModalOpen && (
				<HealthPlanCreateConfirmModal
					title='component.healthPlanCreateConfirm.title'
					imageSource='/dist/icons/v2/check-green.svg'
					text={t('component.healthPlanCreateConfirm.text') ?? ''}
					isOpen={isCreateConfirmModalOpen}
					onClose={afterPlanCreate}
					patientId={patientId}
					flyerType={Flyer.MEDDI_BABY_LATAM}
				/>
			)}

			{createIsRunning && <FullPageLoading />}
		</>
	);
};

export default HealthPlanBabyCreate;
